export default "__VITE_ASSET__DWetnUK9__"